import { useQuery } from "@apollo/client/react";
import { MatchResultCountDocument } from "@/graphql/generated/operations";

// Genesis hides MatchResult.matchId (readable:false), so counts can't be fanned in via one query
// — each caller mounts its own filtered totalCount query; Apollo parallelises + caches these
// across visits. Shared by MatchPage's own history grid and Home's match preview, so both read
// "does this match have a saved result" the same way.
export function useSavedResultCount(matchId: string): number {
  const { data } = useQuery(MatchResultCountDocument, {
    // kept:true only — unsaved solve drafts (kept=false) must not inflate the saved-results count.
    variables: { input: { first: 0, where: { matchId: { eq: matchId }, kept: { eq: true } } } },
    fetchPolicy: "cache-first",
  });
  return data?.matchResults.totalCount ?? 0;
}
